type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "dark" | "light";
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  tone = "dark",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const titleColor = tone === "dark" ? "text-foreground-950" : "text-background-50";
  const descColor = tone === "dark" ? "text-foreground-600" : "text-background-100/80";

  return (
    <div className={`${isCenter ? "text-center mx-auto max-w-3xl" : "text-left max-w-3xl"}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label font-semibold tracking-[0.2em] uppercase text-primary-600 mb-3">
          <span className="w-6 h-px bg-primary-500"></span>
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading text-2xl md:text-4xl font-bold tracking-tight leading-snug ${titleColor}`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-4 text-sm md:text-base leading-relaxed ${descColor}`}>{description}</p>
      )}
    </div>
  );
}